let children = [];
children.push({
    path: "/logistica/ordenes",
    name: "LGS_ORDER",
    component: () =>
        import ("../views/Logistics/OrderPurchase/Orders.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Orden de Compra", href: "/logistica/ordenes" },
        ],
    },
});
children.push({
    path: "/logistica/GestorGrupoArticulo",
    name: "LGSGESGRPART",
    component: () =>
        import ("../views/Logistics/ItemsGroupArticle.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Gestor por grupo articulo", href: "/logistica/GestorGrupoArticulo" },
        ],
    },
});
children.push({
    path: "/logistica/consultas/ubicaciones",
    name: "LGS_LOCATIONS",
    component: () =>
        import ("../views/Logistics/ConsultingSAP/Locations.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Consultas SAP", disabled: true },
            { text: "Ubicaciones", href: "/logistica/consultas/ubicaciones" },
        ],
    },
});
children.push({
    path: "/logistica/Requerimientos/Servicios",
    name: "LGS_SERVICE_REQUIREMENT",
    component: () =>
        import ("../views/Logistics/Requirement/RequirementServices.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Requerimientos", disabled: true },
            { text: "Servicios", href: "/logistica/Requerimientos/Servicios" },
        ],
    },
});
children.push({
    path: "/logistica/Requerimientos/Compras",
    name: "LGS_PURCHASE_REQUIREMENT",
    component: () =>
        import ("../views/Logistics/Requirement/RequirementPurchase.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Requerimientos", disabled: true },
            { text: "Compras", href: "/logistica/Requerimientos/Compras" },
        ],
    },
});
children.push({
    path: "/logistica/Requerimientos/Pedido",
    name: "LGS_WAREHOUSE_REQUIREMENT",
    component: () =>
        import ("../views/Logistics/Requirement/RequirementWareHouse.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Requerimientos", disabled: true },
            { text: "Pedido", href: "/logistica/Requerimientos/Pedido" },
        ],
    },
});
children.push({
    path: "/logistica/orderTraceability",
    name: "LGS_ORDERTRACEABILITY",
    component: () =>
        import ("../views/Logistics/OrderTraceability/OrderTraceability.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Trazabilidad Pedido", href: "/logistica/orderTraceability" },
        ],
    },
});
children.push({
    path: "/logistica/Requerimientos_Servicios/Atencion",
    name: "LGS_SERVICE_ATTENTION",
    component: () =>
        import ("../views/Logistics/Requirement/ServiceAttention.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Requerimientos", disabled: true },
            { text: "Servicios", href: "/logistica/Requerimientos_Servicios/Atencion" },
        ],
    },
});
children.push({
    path: "/logistica/consultas/ubicaciones",
    name: "LGS_REQUIREMENT_ARTICLE",
    component: () =>
        import ("../views/Logistics/ConsultingSAP/Locations.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Consultas SAP", disabled: true },
            { text: "Ubicaciones", href: "/logistica/consultas/ubicaciones" },
        ],
    },
});
children.push({
    path: "/logistica/consultas/ubicaciones",
    name: "LGS_REQUIREMENT_ORDER",
    component: () =>
        import ("../views/Logistics/ConsultingSAP/Locations.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Consultas SAP", disabled: true },
            { text: "Ubicaciones", href: "/logistica/consultas/ubicaciones" },
        ],
    },
});
children.push({
    path: "/logistica/ordenpedido/atencionpedido",
    name: "LGS_ORDER_STORE_ATTENTION",
    component: () =>
        import ("../views/Logistics/OrderStore/OrderStoreAttention.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Ordenes Pedido", disabled: true },
            { text: "Atencion", href: "/logistica/ordenpedido/atencionpedido" },
        ],
    },
});

children.push({
    path: "/logistica/ordenpedido/historialpedido",
    name: "LGS_ORDER_STORE_HISTORY",
    component: () =>
        import ("../views/Logistics/OrderStore/StoreOrderHistory.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Ordenes Pedido", disabled: true },
            { text: "Historial de Pedidos", href: "/logistica/ordenpedido/historialpedido" },
        ],
    },
});

children.push({
    path: "/logistica/permisos",
    name: "LGS_PERMIT",
    component: () =>
        import ("../views/Logistics/Permits/Permit.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Permisos", href: "/logistica/permisos" },
        ],
    },
});
children.push({
    path: "/logistica/ordenpedido/solicitudpedido",
    name: "LGS_ORDER_STORE_REQUEST",
    component: () =>
        import ("../views/Logistics/OrderStore/OrderStoreRequest.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Ordenes Pedido", disabled: true },
            { text: "Solicitud de Pedido", href: "/logistica/ordenpedido/solicitudpedido" },
        ],
    },
});
children.push({
    path: "/logistica/ordenpedido/atencioncompra",
    name: "LGS_PURCHASE_ORDER_ATTENTION",
    component: () =>
        import ("../views/Logistics/OrderStore/OrderPurcharseAttention.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Ordenes Pedido", disabled: true },
            { text: "Atencion de Compra", href: "/logistica/ordenpedido/atencioncompra" },
        ],
    },
});
children.push({
    path: "/logistica/cotizaciones",
    name: "LGS_QUOTE",
    component: () =>
        import ("../views/Logistics/Quote/Quote.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Cotizaciones", href: "/logistica/cotizaciones" },
        ],
    },
});
children.push({
    path: "/logistica/articulos/asignacion",
    name: "LGS_VARTICLES",
    component: () =>
        import ("../views/Logistics/Articles/VArticles.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Articulos", href: "/logistica/articulos/asignacion" },
        ],
    },
});
children.push({
    path: "/logistica/MantenimientoArticulos",
    name: "LGS_MAINTENANCEVARTICLES",
    component: () =>
        import ("../views/Logistics/Articles/MaintenanceArticles.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Articulos", href: "/logistica/MantenimientoArticulos" },
        ],
    },
});

children.push({
    path: "/logistica/liberacionarticulo",
    name: "LGS_ARTICLE_FREE",
    component: () =>
        import ("../views/Logistics/Articles/ArticleFree.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Liberación", href: "/logistica/liberacionarticulo" },
        ],
    },
});

children.push({
    path: "/logistica/guiaremision",
    name: "LGS_REFERRAL_GUIDE",
    component: () =>
        import ("../views/Logistics/ReferralGuide/LgsReferralGuide.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Guías de Remisión", disabled: true },
            { text: "Emitir Guía", href: "/logistica/guiaremision" },
        ],
    },
});
children.push({
    path: "/logistica/consultas/requermientoFlujograma",
    name: "REQFLUJOGR",
    component: () =>
        import ("../views/Logistics/Requirement/RequirementFlowChart.vue"), 
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Consultas SAP", disabled: true },
            { text: "requermientoFlujograma", href: "/logistica/consultas/requermientoFlujograma" },
        ],
    },
});
children.push({
    path: "/logistica/salida_kit_seguridad",
    name: "LGS_EXIT_SEALS",
    component: () =>
        import ("../views/Logistics/ExitSeals/ExitSeals.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Salida de Kit de Seguridad", href: "/logistica/salida_kit_seguridad" },
        ],
    },
});
children.push({
    path: "/logistica/cotizaciones/atencion",
    name: "LGS_QUOTE_ATTENTION",
    component: () =>
        import ("../views/Logistics/Quote/QuoteAttention.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Cotizaciones", disabled: true },
            { text: "Atención de Cotizaciones", href: "/logistica/cotizaciones/atencion" },
        ],
    },
});
children.push({
    path: "/logistica/cotizaciones/historial",
    name: "LGS_QUOTE_HISTORY",
    component: () =>
        import ("../views/Logistics/Quote/QuoteHistory.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Cotizaciones", disabled: true },
            { text: "Historial de Cotizaciones", href: "/logistica/cotizaciones/historial" },
        ],
    },
});
children.push({
    path: "/logistica/dashboard",
    name: "LGS_PACKAGING_DASHBOARD",
    component: () =>
        import ("../views/Logistics/PackagingDashboard/PackagingDashboard.vue"),
    meta: {
        authenticated: true,
        fullScreenLayout: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Dashboard", href: "/logistica/dashboard" },
        ],
    },
});
children.push({
    path: "/logistica/control-transito-envases",
    name: "LGS_CONTAINER_MOVEMENT",
    component: () =>
        import ("../views/Logistics/ContainerMovement/ContainerMovement.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Control de Materiales", href: "/logistica/control-transito-envases" },
        ],
    },
});
children.push({
    path: "/logistica/maestro-envases",
    name: "LGS_CONTAINER_MASTER",
    component: () =>
        import ("../views/Logistics/ContainerMaster/ContainerMaster.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Maestro de Envases", href: "/logistica/maestro-envases" },
        ],
    },
});
children.push({
    path: "/logistica/inventario-envases",
    name: "LGS_CONTAINER_INVENTORY",
    component: () =>
        import ("../views/Logistics/ContainerInventory/ContainerInventory.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Inventario de Envases", href: "/logistica/inventario-envases" },
        ],
    },
});
children.push({
    path: "/logistica/dashboard-envases",
    name: "LGS_CONTAINER_DASHBOARD",
    component: () =>
        import ("../views/Logistics/ContainerDashboard/ContainerDashboard.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Dashboard de Envases", href: "/logistica/dashboard-envases" },
        ],
    },
});
children.push({
    path: "/logistica/Transferencia_Almacenes/Solicitud",
    name: "LGS_WAREHOUSE_TRANSFER_REQUEST",
    component: () =>
        import ("../views/Logistics/WarehouseTransfer/WarehouseTransferRequest.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Transferencia Almacenes", disabled: true },
            { text: "Solicitud", href: "/logistica/Transferencia_Almacenes/Solicitud" },
        ],
    },
});
children.push({
    path: "/logistica/Transferencia_Almacenes/Atencion",
    name: "LGS_WAREHOUSE_TRANSFER_ATTENTION",
    component: () =>
        import ("../views/Logistics/WarehouseTransfer/WarehouseTransferAttention.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Logistica", disabled: true },
            { text: "Transferencia Almacenes", disabled: true },
            { text: "Atención", href: "/logistica/Transferencia_Almacenes/Atencion" },
        ],
    },
});
export { children }